import { SVGAttributes } from 'react';
import dynamic from 'next/dynamic';

export const ICON_MAP = {
  alertCircle: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/AlertCircle').then((mod) => mod.AlertCircle)
  ),
  arrow: dynamic(() => import('@sprd/sprd-component-kit/v2/icons/Arrow').then((mod) => mod.Arrow)),
  arrowRight: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/ArrowRight').then((mod) => mod.ArrowRight)
  ),
  basketNumber: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/BasketNumber').then((mod) => mod.BasketNumber)
  ),
  basketSimple: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/BasketSimple').then((mod) => mod.BasketSimple)
  ),
  caret: dynamic(() => import('@sprd/sprd-component-kit/v2/icons/Caret').then((mod) => mod.Caret)),
  chevron: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/Chevron').then((mod) => mod.Chevron)
  ),
  chevrons: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/Chevrons').then((mod) => mod.Chevrons)
  ),
  checkcircle: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/CheckCircle').then((mod) => mod.CheckCircle)
  ),
  close: dynamic(() => import('@sprd/sprd-component-kit/v2/icons/Close').then((mod) => mod.Close)),
  copy: dynamic(() => import('@sprd/sprd-component-kit/v2/icons/Copy').then((mod) => mod.Copy)),
  dollar: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/Dollar').then((mod) => mod.Dollar)
  ),
  facebook: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/Facebook').then((mod) => mod.Facebook)
  ),
  filter: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/Filter').then((mod) => mod.Filter)
  ),
  heart: dynamic(() => import('@sprd/sprd-component-kit/v2/icons/Heart').then((mod) => mod.Heart)),
  instagram: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/Instagram').then((mod) => mod.Instagram)
  ),
  lock: dynamic(() => import('@sprd/sprd-component-kit/v2/icons/Lock').then((mod) => mod.Lock)),
  linkedIn: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/LinkedIn').then((mod) => mod.LinkedIn)
  ),
  menu: dynamic(() => import('@sprd/sprd-component-kit/v2/icons/Menu').then((mod) => mod.Menu)),
  moodSad: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/MoodSad').then((mod) => mod.MoodSad)
  ),
  moodSmile: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/MoodSmile').then((mod) => mod.MoodSmile)
  ),
  pinterest: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/Pinterest').then((mod) => mod.Pinterest)
  ),
  search: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/Search').then((mod) => mod.Search)
  ),
  spreadgroupLogo: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/SpreadgroupLogo').then((mod) => mod.SpreadgroupLogo)
  ),
  spreadIcon: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/SpreadIcon').then((mod) => mod.SpreadIcon)
  ),
  spreadliveLogo: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/SpreadliveLogo').then((mod) => mod.SpreadliveLogo)
  ),
  spreadConnectLogo: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/SpreadConnectLogo').then(
      (mod) => mod.SpreadConnectLogo
    )
  ),
  spreadLogo: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/SpreadLogo').then((mod) => mod.SpreadLogo)
  ),
  spreadshirtLogo: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/SpreadshirtLogo').then((mod) => mod.SpreadshirtLogo)
  ),
  spreadshirtProLogo: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/SpreadshirtProLogo').then(
      (mod) => mod.SpreadshirtProLogo
    )
  ),
  spreadshopLogo: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/SpreadshopLogo').then((mod) => mod.SpreadshopLogo)
  ),
  teamshirtsLogo: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/TeamshirtsLogo').then((mod) => mod.TeamshirtsLogo)
  ),
  television: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/Television').then((mod) => mod.Television)
  ),
  tiktok: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/TikTok').then((mod) => mod.TikTok)
  ),
  toggleLeft: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/ToggleLeft').then((mod) => mod.ToggleLeft)
  ),
  toggleRight: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/ToggleRight').then((mod) => mod.ToggleRight)
  ),
  trash: dynamic(() => import('@sprd/sprd-component-kit/v2/icons/Trash').then((mod) => mod.Trash)),
  truck: dynamic(() => import('@sprd/sprd-component-kit/v2/icons/Truck').then((mod) => mod.Truck)),
  twitter: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/Twitter').then((mod) => mod.Twitter)
  ),
  userCheck: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/UserCheck').then((mod) => mod.UserCheck)
  ),
  user: dynamic(() => import('@sprd/sprd-component-kit/v2/icons/User').then((mod) => mod.User)),
  youtube: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/Youtube').then((mod) => mod.Youtube)
  ),
  at: dynamic(() => import('@sprd/sprd-component-kit/v2/icons/At').then((mod) => mod.At)),
  arrowBack: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/ArrowBack').then((mod) => mod.ArrowBack)
  ),
  buildingStore: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/BuildingStore').then((mod) => mod.BuildingStore)
  ),
  brush: dynamic(() => import('@sprd/sprd-component-kit/v2/icons/Brush').then((mod) => mod.Brush)),
  colorSwatch: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/ColorSwatch').then((mod) => mod.ColorSwatch)
  ),
  dropletFilled: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/DropletFilled').then((mod) => mod.DropletFilled)
  ),
  envelope: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/Envelope').then((mod) => mod.Envelope)
  ),
  mail: dynamic(() => import('@sprd/sprd-component-kit/v2/icons/Mail').then((mod) => mod.Mail)),
  message: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/Message').then((mod) => mod.Message)
  ),
  phoneCall: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/PhoneCall').then((mod) => mod.PhoneCall)
  ),
  sort: dynamic(() => import('@sprd/sprd-component-kit/v2/icons/Sort').then((mod) => mod.Sort)),
  leaf: dynamic(() => import('@sprd/sprd-component-kit/v2/icons/Leaf').then((mod) => mod.Leaf)),
  needle: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/Needle').then((mod) => mod.Needle)
  ),
  minus: dynamic(() => import('@sprd/sprd-component-kit/v2/icons/Minus').then((mod) => mod.Minus)),
  plus: dynamic(() => import('@sprd/sprd-component-kit/v2/icons/Plus').then((mod) => mod.Plus)),
  checkmark: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/Checkmark').then((mod) => mod.Checkmark)
  ),
  intersect: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/Intersect').then((mod) => mod.Intersect)
  ),
  discount: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/Discount').then((mod) => mod.Discount)
  ),
  discount2: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/Discount2').then((mod) => mod.Discount2)
  ),
  star: dynamic(() => import('@sprd/sprd-component-kit/v2/icons/Star').then((mod) => mod.Star)),
  refresh: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/Refresh').then((mod) => mod.Refresh)
  ),
  gift: dynamic(() => import('@sprd/sprd-component-kit/v2/icons/Gift').then((mod) => mod.Gift)),
  hanger: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/Hanger').then((mod) => mod.Hanger)
  ),
  shirt: dynamic(() => import('@sprd/sprd-component-kit/v2/icons/Shirt').then((mod) => mod.Shirt)),
  shoppingCart: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/ShoppingCart').then((mod) => mod.ShoppingCart)
  ),
  photo: dynamic(() => import('@sprd/sprd-component-kit/v2/icons/Photo').then((mod) => mod.Photo)),
  seeding: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/Seeding').then((mod) => mod.Seeding)
  ),
  basketball: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/Basketball').then((mod) => mod.Basketball)
  ),
  thumbsUp: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/ThumbsUp').then((mod) => mod.ThumbsUp)
  ),
  party: dynamic(() => import('@sprd/sprd-component-kit/v2/icons/Party').then((mod) => mod.Party)),
  cat: dynamic(() => import('@sprd/sprd-component-kit/v2/icons/Cat').then((mod) => mod.Cat)),
  speechbubble: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/Speechbubble').then((mod) => mod.Speechbubble)
  ),
  football: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/Football').then((mod) => mod.Football)
  ),
  headphones: dynamic(() =>
    import('@sprd/sprd-component-kit/v2/icons/Headphones').then((mod) => mod.Headphones)
  ),
};

type DynamicIconProps = Omit<SVGAttributes<SVGElement>, 'icon' | 'type'> & {
  icon: string | undefined | keyof typeof ICON_MAP;
};

export const isDynamicIcon = (icon: string | undefined): icon is keyof typeof ICON_MAP => {
  return !!icon && icon in ICON_MAP;
};

const DynamicIcon = ({ icon, ...svgProps }: DynamicIconProps) => {
  const IconComponent = isDynamicIcon(icon) ? ICON_MAP[icon] : undefined;
  if (!IconComponent) {
    console.warn(`Icon "${icon}" is not valid.`);
    return null;
  }
  return <IconComponent {...svgProps} />;
};

export default DynamicIcon;
